import { createFileRoute } from '@tanstack/react-router';
import { ForgotPasswordFlow } from '../../../../components/auth/forgot-password-flow';

export const Route = createFileRoute('/subdomain/app/_auth/forgot-password')({
  component: () => <ForgotPasswordFlow signInTo="/subdomain/app/sign-in/email" />,
});
